import * as React from 'react';

const LoadMore = (props) => <div className='load-more-container'>{props.title}</div>;

export default LoadMore;
